import { DataHistory, DataModel } from '@shared/models/data-model';

export class PresentUserData extends DataModel {
  constructor(
    id: string,
    meta: Partial<DataHistory>,
    public readonly displayName: string,
    public readonly deviceId: string,
    public readonly deviceName: string,
    public readonly devicePcName: string,
    public readonly platformOpen: boolean,
    public readonly lastChangedOn: string
  ) {
    super(id, meta);
  }

  get deviceDisplayName(): string {
    return `${this.devicePcName} - ${this.deviceName}`;
  }

  get status(): 'Aangemeld' | 'Aanwezig' {
    return this.platformOpen ? 'Aangemeld' : 'Aanwezig';
  }
}
